import { on } from "@ngrx/store";

import { isNil } from "lodash";

import { MutateObjectState } from "../mutate-object/mutate-object.state";

import { JobMutateDiscountActions } from "./mutate-discount.actions";

export const jobMutateDiscountsReducer = [
  on(JobMutateDiscountActions.discountNameInputChanged, (state: MutateObjectState, { discountName }): MutateObjectState => {
    return {
      ...state,
      mutateObjectDialog: {
        ...state.mutateObjectDialog,
        mutators: {
          ...state.mutateObjectDialog.mutators,
          discount: {
            ...state.mutateObjectDialog.mutators.discount,
            discountName,
          }
        }
      }
    };
  }),
  on(JobMutateDiscountActions.amountInputChanged, (state: MutateObjectState, { amount }): MutateObjectState => {
    return {
      ...state,
      mutateObjectDialog: {
        ...state.mutateObjectDialog,
        mutators: {
          ...state.mutateObjectDialog.mutators,
          discount: {
            ...state.mutateObjectDialog.mutators.discount,
            amount,
          }
        }
      }
    };
  }),
  on(JobMutateDiscountActions.discountTypeSelected, (state: MutateObjectState, { discountType }): MutateObjectState => {

    let amount = state.mutateObjectDialog.mutators.discount.amount;

    if (discountType === 'percentage' && !isNil(amount)) {
      amount = Math.min(amount, 100);
    }

    return {
      ...state,
      mutateObjectDialog: {
        ...state.mutateObjectDialog,
        mutators: {
          ...state.mutateObjectDialog.mutators,
          discount: {
            ...state.mutateObjectDialog.mutators.discount,
            discountType,
            amount,
          }
        }
      }
    };
  }),
  on(JobMutateDiscountActions.eventSelectionChanged, (state: MutateObjectState, { eventIds }): MutateObjectState => {
    return {
      ...state,
      mutateObjectDialog: {
        ...state.mutateObjectDialog,
        mutators: {
          ...state.mutateObjectDialog.mutators,
          discount: {
            ...state.mutateObjectDialog.mutators.discount,
            eventIds,
          }
        }
      }
    };
  }),
];
